import { Api } from '../AApi'

export const API_MAPSHARE = new Api(
    {
        url: 'map-share',
        isConvertFormData: false,
    },
    {
        getMapData: {
            async request(params) {
                return this.sdk
                    .request({
                        method: 'get',
                        url: `show-map`,
                        params,
                    })
                    .then((res) => res.data)
            },
        }
    }
)
